import axios from 'axios';
import {loadStorage} from "./sessionStorage";
import _ from 'lodash';
import {createMessageRequestException} from './fanctionUtility'
import store from './store'

const urlWhitelist = [
    "/v1/timbratura/inserisci/automatica",
    "/v1/timbratura/inserisci/manuale",
    "/v1/giustificativo/inserisci"
]

const _instance = axios.create({
    baseURL: loadStorage().configurationFile != null ? loadStorage().configurationFile.fileConf.baseUrlService : '',
    headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': 0,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': 'it',
        common: {
            Authorization: loadStorage().auth && !_.isEmpty(loadStorage().auth.token) ?
                `Bearer ${loadStorage().auth.token}` : '',
            Ruolo: loadStorage().auth && loadStorage().auth.ruoloScelto ? `${loadStorage().auth.ruoloScelto}` : 'none'
        }
    }
});

_instance.interceptors.request.use(
    request => checkAuthorization(request)
);

_instance.interceptors.response.use(
    response => {return response},
    error => handleResponseError(error)
);

_instance.interceptors.request.use(
    request => removeCacheHeadersArpa(request)
);
const removeCacheHeadersArpa = (request) => {

    if(request.url.includes('auth.regione.toscana.it')) {
        delete request.headers['Pragma'];
        delete request.headers['Expires'];
        delete request.headers['Cache-Control'];
        delete request.headers.common['Ruolo']
    }
    
    return request;
} 

const requestControllers = new Map();

_instance.interceptors.request.use((config) => {
    if (requestControllers.has(config.url) && !urlWhitelist.includes(config.url)) {
        requestControllers.get(config.url).abort();
        requestControllers.delete(config.url);
    }

    const controller = new AbortController();
    config.signal = controller.signal;
    
    requestControllers.set(config.url, controller);
    
    return config;
}, (error) => Promise.reject(error));

_instance.interceptors.response.use(
    (response) => {
        requestControllers.delete(response.config.url);
        return response;
    },
    (error) => {
        requestControllers.delete(error.config?.url);
        return handleResponseError(error);
    }
);

export const cancelAllRequests = () => {
    requestControllers.forEach((controller) => controller.abort());
    requestControllers.clear();
};

window.addEventListener('beforeunload', cancelAllRequests);
 
const handleResponseError = (error) => {
    if (error.response) {
        if (error.response.status === 502) {
            store.dispatch({
                type: 'NOTIF_SEND',
                payload: {type: 'danger', message: createMessageRequestException("ERRORE: Si è verificato un errore durante il recupero dei dati. Si prega di riprovare più tardi"), dismissAfter: 10000}
            })
        }

                if (error.response.status === 401 || error.response.status === 403) {
            const isUtenteDisabilitato = error.response.status === 403 && error.response.data === 'Utente disabilitato';
            store.dispatch({
                type: 'NOTIF_SEND',
                payload: {type: 'danger', message: createMessageRequestException(isUtenteDisabilitato ? "Il tuo account è stato disabilitato. Contatta l'amministratore di sistema." : "Sessione scaduta. Effettuare nuovamente l'accesso"), dismissAfter: 10000}
            })
            store.dispatch({type: 'INIT_AUTH'});
            sessionStorage.clear();
            const basePath = window.location.origin + window.location.pathname;
            window.location.assign(isUtenteDisabilitato ? `${basePath}#/login?disabilitato=true` : `${basePath}#/login`);
        }
    }
    return Promise.reject(error);
};

const checkAuthorization = (request) => {
    if (request.headers.common['Authorization'] && request.headers.common['Authorization'] !== '') {
        return request
    } else if (loadStorage().auth && !_.isEmpty(loadStorage().auth.token) && request.headers['Authorization'] && request.headers['Authorization'] !== '') {
        request.headers.common.Authorization = `${loadStorage().auth.token.tipoToken} ${loadStorage().auth.token.token}`;
        return request;
    }
    return request;
};

export default _instance;
